/**
 * using mui-material has the benefit of auto-adjusting colors based on dark/light mode from theme.js
 */
import { Button } from "@mui/material"
import React from "react"


export function ButtonPrimary({ children, ...restProps }) {
    return (
        <Button variant="contained" color="primary" className="button-main-style" {...restProps}>
            {children}
        </Button>
    )
}

export function ButtonSecondary({ children, ...restProps }) {
    return (
        <Button variant="contained" color="secondary" className="button-main-style" {...restProps}>
            {children}
        </Button>
    )
}

export function ButtonPrimaryOutlined({ children, ...restProps }) {
    return (
        <Button variant="outlined" color="primary" className="button-main-style" {...restProps}>
            {children}
        </Button>
    )
}

export function ButtonSecondaryOutlined({ children, ...restProps }) {
    // color="secondary"
    return (
        <Button variant="outlined" color="secondary" className="button-main-style" {...restProps}>
            {children}
        </Button>
    )
}


/* WIP/archive
import React from "react"

import * as UIlib from 'tokkenr-ui-lib';
console.log("UIlib=", UIlib)
import {
    ButtonPrimary, ButtonPrimaryOutlined, ButtonSecondary, ButtonSecondaryOutlined
} from "tokkenr-ui-lib"

export { ButtonPrimary, ButtonPrimaryOutlined, ButtonSecondary, ButtonSecondaryOutlined }
*/
/*
import TokkenrUI from "tokkenr-ui-lib"
import { theme } from "./theme.js";

// inject theme created by createTheme() from "@mui/material/styles"
const tokkenrUI = new TokkenrUI({ theme: theme });

// Now you can use the dynamically loaded and themed components
const ButtonPrimary = tokkenrUI.ButtonPrimary;
const ButtonPrimaryOutlined = tokkenrUI.ButtonPrimaryOutlined;
const ButtonSecondary = tokkenrUI.ButtonSecondary;
const ButtonSecondaryOutlined = tokkenrUI.ButtonSecondaryOutlined;

export { ButtonPrimary, ButtonPrimaryOutlined, ButtonSecondary, ButtonSecondaryOutlined }
*/


